import { create } from 'zustand';

/** Business code of the API's 426 answer to an app older than the minimum version. */
export const APP_UPDATE_REQUIRED = 'APP_UPDATE_REQUIRED';

interface AppUpdateRequiredState {
  required: boolean;
  markRequired: () => void;
}

/**
 * Set by the HTTP client on the API's refusal; never cleared: only installing
 * the new version (a fresh launch) lifts it.
 */
export const useAppUpdateRequired = create<AppUpdateRequiredState>((set) => ({
  required: false,
  markRequired: () => set({ required: true }),
}));
